module.exports = __webpack_public_path__ + "static/media/umbrella-Purplish-blue.87f6b224.svg";